import React, { useEffect, useRef, useState } from 'react';
import './AccessRequestForm.css';
import InputTextBox from '../../components/InputTextBox/InputTextBox';
import SelectDropdown from '../../components/SelectDropDown/SelectDropDown';
import MultilineTextbox from '../../components/MultilineTextbox/MultilineTextbox';
import Button from '../../components/Buttons/Button';
import { Input, Modal, Row, Skeleton, Table } from 'antd';
import Checkbox from '../../components/CheckBox/checkbox';
import { getUserRole } from '../../utilities/CommonHelper';
import { getUserAccessData } from '../../utilities/sessionHelper';
import Link from 'antd/es/typography/Link';
import InfoIcon from "../../assets/info_icon.svg";
import { InfoCircleOutlined } from '@ant-design/icons';
import FloatLabel from '../../components/FloatLabel/floatLabel';

interface Props {
  onSubmit: (event: any) => void;
  onCancel: () => void;
  data: any;
  type: string;
  editable: boolean;
  roles:any[];
}

const form_fields: {
  label: string;
  placeholder: string;
  id: string;
  required: boolean;
  disabled: boolean;
  type: 'textbox' | 'selectDropdown' | 'multilineTextbox' | 'checkbox';
}[] = [
  {
    label: 'Employee ID',
    placeholder: 'IND1234',
    id: 'id',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'Email Address',
    placeholder: 'abc.xyz@indegene.com',
    id: 'email',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'Name',
    placeholder: 'Sam Smith',
    id: 'name',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'BU',
    placeholder: 'Enterprise',
    id: 'businessUnit',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'Department',
    placeholder: 'Organization Development',
    id: 'department',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'Reporting Manager Name',
    placeholder: 'John Doe',
    id: 'reportingManagerName',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'Reporting Manager Email Address',
    placeholder: 'abc.xyz@indegene.com',
    id: 'reportingManagerEmail',
    required: false,
    disabled: true,
    type: 'textbox',
  },
  {
    label: 'Role',
    placeholder: 'Select Role',
    id: 'role',
    required: true,
    disabled: false,
    type: 'selectDropdown',
  },
  {
    label: 'Revoke',
    placeholder: '',
    id: 'revoke',
    required: false,
    disabled: false,
    type: 'checkbox',
  },
  {
    label: 'Reason',
    placeholder: 'Reason',
    id: 'accessReason',
    required: true,
    disabled: false,
    type: 'multilineTextbox',
  },
];

const AccessRequestForm: React.FC<Props> = ({ onSubmit, onCancel, data, type, editable, roles }) => {
  const [sfData, setSFData] = useState<any>({});
  const [revokeChecked, setRevokeChecked] = useState<boolean>(false);
  const [roleOptions, setRoleOptions] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [reason, setReason] = useState('');
  const selectRef = useRef<any>(null);
        
  const handleChangedValue = (id: string, newvalue: string, oldvalue: string | null) => {
    // selectRef.current?.blur();
    let tempData = { ...sfData };
    tempData[id] = newvalue.replace(/\s+/g, ' ');
    setSFData(tempData);
    if(id==="accessReason"){
      setReason(newvalue);
    }
  };

  useEffect(() => {
    setSFData(data);
    setReason(data.accessReason);
  }, [data]);

  const getValidation = (data: any) => {
    let flag = false;
    if(revokeChecked){
        if ( !data['email'] || !data['accessReason']) {
          flag = true;
        }
    }
    else{
        form_fields.forEach((field) => {
          if (field.required) {
              if (data[field.id] === undefined || data[field.id] === '') {
                flag = true;
              }
          }
        });
  }
    return flag;
  };

  // const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   onSubmit(event);
  // };

  const getvaluestoSubmit = () => {
    let tempData = { ...sfData };
    let userRole=getUserRole(getUserAccessData()?.roleAccessMap)
    let values: any = {
      type: revokeChecked?'REVOKE': type.toUpperCase(),
      employeeName: tempData.name,
      employeeEmail: tempData.email,
      employeeId: tempData.id,
      businessUnit: tempData.businessUnit,
      department: tempData.department,
      reportingManagerName: tempData.reportingManagerName,
      reportingManagerEmail: tempData.reportingManagerEmail,
      role: revokeChecked?userRole: tempData.role,
      accessReason: tempData.accessReason,
    };
    return values;
  };
  useEffect(() => {
    if(roles!==undefined && roles!==null){
      setRoleOptions(generateRoleOptions());
    }
  },[roles]);
  const generateRoleOptions = () => {
    let userRole=getUserRole(getUserAccessData()?.roleAccessMap);
    let options:any[]=[];
    Array.isArray(roles) && roles.map((role:any) => {
      if(userRole!==role.name && role.name!=="Ops Lead"){
        options.push({label:role.name,value:role.name});
      }

    });
    return options.sort((a: any, b: any) => a.label.localeCompare(b.label));
  }

  return (
    <div style={{ background: '#F2F6FA', margin: '15px', padding: '15px' }}>
      <div className="form-component" style={{ maxWidth: '100%' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {form_fields.map((field) => {
            if (field.type === 'textbox') {
              let _id = field.id;
              return (
                <>
                  {Object.keys(sfData) ? (
                    // <FloatLabel label={field.label} name={field.label} value={{ label: sfData[_id], value: sfData[_id] }}>
                    // <Input 
                    // style={{ width: 400,height:58,marginRight:'10px' }}
                    // size='large'
                    // value={sfData[_id]} 
                    // id={field.id}
                    //  disabled={editable ? editable : field.disabled} 
                    //  onChange={e => handleChangedValue(field.id,e.target.value,sfData[_id])} />
                    // </FloatLabel>
                    <InputTextBox
                      label={field.label}
                      value={sfData[_id]} //change logic to get value from state
                      placeholder={field.placeholder}
                      id={field.id}
                      required={field.required}
                      disabled={editable ? editable : field.disabled}
                      onChange={handleChangedValue}
                    />
                  ) : (
                    <Skeleton.Input style={{ width: '400px' }} active={true} size="default" />
                  )}
                </>
              );
            } else if (field.type === 'selectDropdown') {
              let _id = field.id;
              return (
                <>
                  {sfData ? (
                    <div style={{display:'flex',width:'400px',marginRight:'20px'}}>
                    <SelectDropdown
                      label={field.label}
                      value={{ label: sfData[_id], value: sfData[_id] }} //change logic to get value from state
                      placeholder={field.placeholder}
                      id={field.id}
                      required={field.required}
                      disabled={editable ? editable : field.disabled || revokeChecked}
                      width={field.label==='Role'?'360px':'400px'}
                      options={roleOptions.length>0?roleOptions:[{ label: sfData[_id], value: sfData[_id] }]}
                      onChange={handleChangedValue}
                    />
                    {field.label==='Role' && 
                    <InfoCircleOutlined  style={{color:'blue', paddingBottom:'15px'}} onClick={() =>setIsModalOpen(true) }/>
                    // <Link onClick={() =>setIsModalOpen(true) }> <img src={InfoIcon} alt='info-icon' /></Link>
                    }
                    </div>
                  ) : (
                    <Skeleton.Input style={{ width: '400px' }} active={true} size="default" />
                  )}
                </>
              );
            } else if (field.type === 'multilineTextbox') {
              let _id = field.id;
              return (
                // <>
                  
                    <div style={{display:'flex',width:'800px',marginRight:'20px',color :'#6c757d',textDecoration:'none'}} >
                    <FloatLabel label="Reason *" value={reason} isMultiSelect={true} reasontype="accessReason">
                    <Input.TextArea
                      value={reason}
                      id={field.id}
                      size='middle'
                      rows={4}
                      style={{ width: '820px', marginRight: '10px',paddingTop:'20px', resize:'none',color:"black" }}
                      required={field.required}
                      disabled={editable ? editable : field.disabled}
                      onChange={(e) => handleChangedValue('accessReason', e.target.value,e.target.value)}
                    />
                    
                  </FloatLabel>
                  </div>
                    // <MultilineTextbox
                    //   label={field.label}
                    //   value={sfData[_id]} //change logic to get value from state
                    //   placeholder={field.placeholder}
                    //   id={field.id}
                    //   required={field.required}
                    //   disabled={editable ? editable : field.disabled}
                    //   onChange={handleChangedValue}
                    // />
                  
                // </>
              );
            } else if (field.type === 'checkbox') {
              let _id = field.id;
              return (
                <>
                  {type === 'edit' ? (
                    <Checkbox
                      label={field.label}
                      checked={revokeChecked}
                      disabled={editable ? editable : field.disabled}
                      onChange={(checked: boolean) => {
                        setRevokeChecked(checked);
                        // if (checked) {
                        //   let tempData = { ...sfData };
                        //   tempData.role = '';
                        //   setSFData(tempData);
                        // }
                      }}
                    />
                  ) : null}
                </>
              );
            }
          })}
        </div>
        <div className="form-buttons" style={{ display: 'flex', justifyContent: 'end' }}>
          {/* {type !== 'new' && <Button label="Cancel" type="cancel" onClick={onCancel} />} */}
          {!editable && (
            <Button
              label="Submit"
              type="submit"
              disabled={getValidation(sfData)}
              onClick={() => onSubmit(getvaluestoSubmit())}
            />
          )}
        </div>
      </div>
      <Modal
          title= "Available Roles and its Responsibilities" 
          open={isModalOpen} 
          onCancel={()=>setIsModalOpen(false)} 
          width={1000} 
          styles={{
            content: {
              borderRadius: '0',
              borderTop: '4px solid #1677ff',
              font: 'normal normal normal 14px/20px Nunito Sans',
            },
          }}
          footer={null}
        >
          {/* <Row>
            <span className='role-heading-style'>Admin : </span>
            <span className='role-desc-style'>Admin is a user who have all the access on myOrders both read and write. This role will be assigned only to the product team/Support Team.</span>
          </Row> */}
          {/* <Row>
            <span className='role-heading-style'>Ops Lead : </span>
            <span className='role-desc-style'>Ops lead can only see Work Orders in which their BU is also mentioned. They can also map PO to workorders.</span>
          </Row> */}
          <Row>
            <span className='role-heading-style' >Sales : </span>
            <span className='role-desc-style'>Sales role will be responsible for linking the SOW to a given opportunity ID and will be able to view all SOWs.</span>
          </Row>
          <Row>
            <span className='role-heading-style'>Finance : </span>
            {/* <span className='role-desc-style'> Responsible for Uploading the PO, creating workorders and also updating the PO Dashboard.</span> */}
              <span className='role-desc-style'>
              Responsible for creating workorders.</span>
          </Row>
          <Row>
            <span className='role-heading-style'>Superuser : </span>
            <span className='role-desc-style'>A role with a read access to everything on myOrders. A user can be assigned additional roles along with super user role.</span>
          </Row>

          <Row>
            <Table
            dataSource={[
            //   {role:"Admin",
            //   userManagement:"Landing Page with Write Access",
            //   orderDashboard:"Write Access",
            //   poDashboard:"Write Access",
            //   workOrderCreation:"Write Access",
            //   opportunityMapping:"Write Access",
            //   reports:"Read Access",
            //   parentIdCreation:"Write Access",
            //   poMapping:"Write Access"
            // },
            // {role:"Ops Lead",
            //   userManagement:"No Access",
            //   orderDashboard:"Landing Page with Write Access (PO Mapping)",
            //   poDashboard:"Read Access",
            //   workOrderCreation:"No Access",
            //   opportunityMapping:"No Access",
            //   reports:"Read Access",
            //   parentIdCreation:"No Access",
            //   poMapping:"Write Access"
            // },
            {role:"Sales",
              userManagement:"No Access",
              orderDashboard:"Landing Page with Write Access",
              poDashboard:"No Access",
              workOrderCreation:"No Access",
              opportunityMapping:"Write Access",
              reports:"Read Access",
              parentIdCreation:"No Access",
              poMapping:"No Access"
            },
            {role:"Finance",
              userManagement:"No Access",
              orderDashboard:"Landing Page with Write Access (Work Order Creation)",
              poDashboard:"Write Access",
              workOrderCreation:"Write Access",
              opportunityMapping:"No Access",
              reports:"Read Access",
              parentIdCreation:"No Access (To be Auto Triggered)",
              poMapping:"Read Access"
            },
            {role:"Superuser",
              userManagement:"Read Access",
              orderDashboard:"Landing Page with Read Access",
              poDashboard:"Read Access",
              workOrderCreation:"Read Access",
              opportunityMapping:"Read Access",
              reports:"Read Access",
              parentIdCreation:"No Access",
              poMapping:"No Access"
            },
            ]}
            columns={[
              {
                title: 'Role',
                dataIndex: 'role',
                key: 'role',
                fixed: 'left',
                width: 100,
              },
                {
                  title: 'User Management',
                  dataIndex: 'userManagement',
                  key: 'userManagement',
                  width: 150,
                },
                {
                  title: 'Order Dashboard',
                  dataIndex: 'orderDashboard',
                  key: 'orderDashboard',
                  width: 150,
                },
                // {
                //   title: 'PO Dashboard',
                //   dataIndex: 'poDashboard',
                //   key: 'poDashboard',
                //   width: 150,
                // },
                {
                  title: 'Work Order Creation',
                  dataIndex: 'workOrderCreation',
                  key: 'workOrderCreation',
                  width: 150,
                },
                {
                  title: 'Opportunity Mapping',
                  dataIndex: 'opportunityMapping',
                  key: 'opportunityMapping',
                  width: 150,
                },
                {
                  title: 'Reports',
                  dataIndex: 'reports',
                  key: 'reports',
                  width: 150,
                },
                {
                  title: 'Parent ID Creation',
                  dataIndex: 'parentIdCreation',
                  key: 'parentIdCreation',
                  width: 150,
                },
                // {
                //   title: 'PO Mapping',
                //   dataIndex: 'poMapping',
                //   key: 'poMapping',
                //   width: 150,
                // },
              ]
            }
            pagination={false}
            className='table-style'
            scroll={{x:'max-content'}} />

          </Row>

        </Modal>
    </div>
  );
};

export default AccessRequestForm;